<template lang="pug">
  .container.grid-lg.py-2
    form.list-filters(@submit.prevent='listar')
      .columns.align-center
        .column.form-group
          small {{ 'doc_publicacao.descricao' | tModel }}
          input.input-sm.form-input.input-sm(type='search' v-model='q.descricao_cont' :placeholder="'doc_publicacao.descricao' | tModel")
        .column.col-auto.form-group
          small {{ 'doc_publicacao.numero' | tModel }}
          int.input-sm.form-input.input-sm(v-model='q.numero_eq' :placeholder="'doc_publicacao.numero' | tModel")
        .column.col-auto.form-group
          small {{ 'doc_publicacao.ano' | tModel }}
          year.input-sm.form-input.input-sm(v-model='q.ano_eq' :placeholder="'doc_publicacao.ano' | tModel")
        .column.col-auto.form-group
          small {{ 'doc_publicacao.situacao' | tModel }}
          select.select-sm.form-select.input-sm(v-model='q.situacao_eq')
            option Todos
            option(v-for="(v, k) in $i18n.t('enums.db.enum_doc_publicacao_situacao')" :value='k') {{ v }}
        .column.col-auto.text-right
          button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
            i.fa.fa-search.fa-lg
        .column.col-auto
          router-link.btn.btn-action.s-circle.tooltip.tooltip-bottom(
            :to="{name: 'fiscalizacao.docPublicacoes.new'}" 
            data-tooltip='Novo'
            v-acl:allowed.admin.fiscalizacao.doc_publicacoes.create
          )
            i.icon.icon-plus
    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        table.table.table-striped.table-sm
          thead
            tr
              th {{ 'doc_publicacao.numero' | tModel }}
              th {{ 'doc_publicacao.descricao' | tModel }}
              th {{ 'doc_publicacao.situacao' | tModel }}
              th {{ 'doc_publicacao.created_at' | tModel }}
              th {{ 'doc_publicacao.publicado_em' | tModel }}
              th.actions-col
          tbody
            tr(v-for="publicacao in list")
              td {{ publicacao.numero }}/{{ publicacao.ano }}
              td {{ publicacao.descricao }}
              td {{ publicacao | enums('doc_publicacao.situacao') }}
              td {{ publicacao.created_at | date }}
              td {{ publicacao.publicado_em | date }}
              td.actions-col
                router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                  :data-tooltip="'views.buttons.show.label' | translate"
                  :to="{name: 'fiscalizacao.docPublicacoes.show', params: {id: publicacao.id}}"
                )
                  i.fa.fa-eye
        .my-2.text-right(v-if='pages > 1')
          btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': vuexDefaultMapping,
  },
  data() {
    return {
      q: {
        descricao_cont: '',
        numero_eq: '',
        ano_eq: '',
        created_at_order_by: 'desc',
      },
    }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
